module.exports = __webpack_public_path__ + "static/media/websignal-dark-orange-medium.e68538a1.png";